export const presenterTypeConstants = {
    WORDCLOUD: 'WORDCLOUD',
    BARCHART: 'BARCHART',
    COLUMNCHART: 'COLUMNCHART',
    PIECHART: 'PIECHART',
    TEXTFLOW: 'TEXTFLOW',
    LINECHART: 'LINECHART',
    RADARCHART: 'RADARCHART',
    POLARAREACHART: 'POLARAREACHART',
    DOUGHNUTCHART: 'DOUGHNUTCHART',
    RATING_CHART: 'RATING_CHART',
    DISPARITYCHART: 'DISPARITYCHART',

    QUIZ: 'QUIZ',
    QUIZANSWER: 'QUIZANSWER',
    SCOREBOARD: 'SCOREBOARD',
    REMOVEDLIST: 'REMOVEDLIST'

}


